import { nrba } from './newRelic'

export class NewRelicConnection {
  constructor (agent = nrba) {
    this._agent = agent
  }

  get agent () {
    return this._agent || (typeof window !== 'undefined' ? window.newrelic : undefined)
  }

  get isAvailable () {
    return Boolean(this.agent)
  }

  setUserId (userId) {
    if (!this.isAvailable || typeof this.agent.setUserId !== 'function') return
    if (userId !== undefined && userId !== null) {
      this.agent.setUserId(String(userId))
    }
  }

  setCustomAttribute (key, value) {
    if (!this.isAvailable || typeof this.agent.setCustomAttribute !== 'function') return
    if (value !== undefined && value !== null) {
      this.agent.setCustomAttribute(key, value)
    }
  }

  setCurrentRouteName (routeName) {
    if (!this.isAvailable || typeof this.agent.setCurrentRouteName !== 'function') return
    if (routeName) {
      this.agent.setCurrentRouteName(routeName)
    }
  }

  noticeError (error, customAttributes = {}) {
    if (!this.isAvailable || typeof this.agent.noticeError !== 'function') return
    if (error) {
      this.agent.noticeError(error, customAttributes)
    }
  }

  addPageAction (name, attributes = {}) {
    if (!this.isAvailable || typeof this.agent.addPageAction !== 'function') return
    if (name) {
      this.agent.addPageAction(name, attributes)
    }
  }

  interaction () {
    if (!this.isAvailable || typeof this.agent.interaction !== 'function') return null
    return this.agent.interaction()
  }
}

export const newRelicConnection = new NewRelicConnection()
